import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import {
  type ConsolidatedMenuItem,
  type MenuBlockType,
  type MenuItem,
} from '../../menu/menu.interfaces';

import { MenuItemComponent } from './menu-item/menu-item.component';

@Component({
  selector: 'myre-menu-items',
  templateUrl: './menu-items.component.html',
  styleUrl: './menu-items.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MenuItemComponent],
})
export class MenuItemsComponent {
  public readonly type = input.required<MenuBlockType>();
  public readonly items = input.required<ConsolidatedMenuItem[]>();

  protected _trackBy(index: number, item: MenuItem): string {
    return `${item.label}-${index}`;
  }
}
